module.exports = __webpack_public_path__ + "static/media/ic-shopping-malls.98629a6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ic-shopping-malls.svg
// module id = 442
// module chunks = 0